// @flow
import React from 'react'
import ImgCover from '../utilities/img-cover'
import Icon from '../icons/icon'

type CardHeaderProps = {
  photo: ?string,
  imagePlaceholder: string
}

const CardHeader = (props: CardHeaderProps) => {
  const { photo, imagePlaceholder } = props
  return (
    <header className='card-header'>
      {photo ? <ImgCover src={photo} /> : <Icon name={imagePlaceholder} />}
    </header>
  )
}

CardHeader.defaultProps = { imagePlaceholder: 'fundrising-events-2' }

export default CardHeader



// WEBPACK FOOTER //
// ./src/ui/cards/card-header.js